import { render, staticRenderFns } from "./mediaPublishImgUpload.vue?vue&type=template&id=6347f802&scoped=true&"
import script from "./mediaPublishImgUpload.vue?vue&type=script&lang=js&"
export * from "./mediaPublishImgUpload.vue?vue&type=script&lang=js&"
import style0 from "./mediaPublishImgUpload.vue?vue&type=style&index=0&id=6347f802&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6347f802",
  null
  
)

component.options.__file = "mediaPublishImgUpload.vue"
export default component.exports